module.exports = __webpack_public_path__ + "img/神华国华孟津发电有限责任公司.204f3e42.jpg";